import { Extension, isNodeSelection } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";

import { nodeIsExpression } from "@/components/tiptap/tiptap-expression/utils";

export const HighlightSelectionOnBlur = Extension.create({
  name: "highlightSelectionOnBlur",

  addProseMirrorPlugins() {
    const { editor } = this;

    return [
      new Plugin({
        key: new PluginKey("highlightSelectionOnBlur"),
        props: {
          decorations(state) {
            if (
              state.selection.empty ||
              (isNodeSelection(state.selection) && nodeIsExpression(state.selection.node))
            ) {
              return null;
            }

            if (editor.isFocused === true) {
              return null;
            }

            if (
              nodeIsExpression(state.doc.nodeAt(state.selection.from)) ||
              nodeIsExpression(state.doc.nodeAt(state.selection.to))
            ) {
              return null;
            }

            return DecorationSet.create(state.doc, [
              Decoration.inline(state.selection.from, state.selection.to, {
                class: "bg-blue-100 dark:bg-blue-900",
              }),
            ]);
          },
        },
      }),
    ];
  },
});
